import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconSuccessfulSolid48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="successful solid">
            <path
                d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z"
                fill={props.fill || '#40e587'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46ZM24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
                fill={props.foregroundcolor || 'black'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.3778 18.4497L20.0959 36.7735L8.60645 25.6123L11.3936 22.7432L20.1264 31.2264L36.6223 15.5502L39.3778 18.4497Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}

export function IconSuccessfulSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="successful solid">
            <path
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                fill={props.fill || '#40e587'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.7216 8.69477L10.0168 17.3212L4.3501 11.6545L5.76431 10.2403L10.0976 14.5735L18.3928 7.19995L19.7216 8.69477Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}

export function IconSuccessfulSolid16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="successful solid">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
                fill={props.fill || '#40e587'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.7785 5.76419L7.05678 11.4859L3.34998 7.62461L4.79275 6.23955L7.08594 8.62829L11.3643 4.34998L12.7785 5.76419Z"
                fill={props.foregroundcolor || 'black'}
            />
        </svg>
    );
}
